module.exports = __webpack_public_path__ + "static/img/info_right.f6e44a7.png";


//////////////////
// WEBPACK FOOTER
// ./static/info_right.png
// module id = Xocc
// module chunks = 1